<template>
  <div>
    <div class="container">
      <el-table :data="list" border style="width: 100%">
        <el-table-column label="页面" prop="name" />
        <el-table-column label="链接" prop="link" />
        <el-table-column label="备注" prop="note" />
      </el-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getCachedStore } from '../../router/auth.js';

export default {
  data() {
    return {
      list: []
    };
  },
  async created() {
    var o = await getCachedStore();
    this.list = [
      {
        name: '首页',
        link: 'pages/home/home?StoreID=' + o.id,
        note: '/'
      },
      {
        name: '分类',
        link: 'pages/category/category?StoreID=' + o.id,
        note: '/'
      },
      {
        name: '我的',
        link: 'pages/mine/mine?StoreID=' + o.id,
        note: '/'
      },
      {
        name: '商品详情',
        link: `pages/product/product?StoreID=${o.id}&id=X`,
        note: '需将X替换商品ID'
      },
      {
        name: '商品列表',
        link: 'pages/productList/productList?StoreID=' + o.id,
        note: '/'
      },
      {
        name: '搜索',
        link: 'pages/search/search?StoreID=' + o.id,
        note: '/'
      },
      {
        name: '购物车',
        link: 'pages/shopcart/shopcart?StoreID=' + o.id,
        note: '/'
      },
      {
        name: '单品周期购',
        link: `pages/subscription/subscription?StoreID=${o.id}&id=X`,
        note: '需将X替换周期购ID'
      },
      {
        name: '自由拼周期购',
        link: `pages/subscriptionGroup/subscriptionGroup?StoreID=${o.id}&id=X`,
        note: '需将X替换周期购ID'
      },
      {
        name: '周期购列表',
        link: `pages/subscriptionList/subscriptionList?StoreID=${o.id}`,
        note: '/'
      }
    ];
  }
};
</script>

<style>
.member {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.member-avatar {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}

.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.input-width {
  width: 170px;
}
.list-nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  color: #999;
}
.list-tabs {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.el-select {
  width: 100%;
}
.item {
  margin-bottom: 10px;
}
.item:last-child {
  margin-bottom: none;
}
.order-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  padding: 5px 10px;
}

.table {
  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  display: flex;
  justify-content: space-between;
}
.products {
  flex: 1;
  border-right: 1px solid #e9e9e9;
}
.action {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.action-text {
  font-size: 14px;
  color: #666;
  padding-bottom: 10px;
}
.invoice {
  background-color: #e9e9e9;
  color: #4ba3dd;
  font-size: 12px;
  padding: 3px;
  border-radius: 3px;
}
.order-detail_text {
  color: #666;
  font-size: 14px;
}
.m10 {
  margin: 0 10px;
}
.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.product {
  display: flex;
  border-bottom: 1px solid #e9e9e9;
}
.product:last-child {
  border-bottom: none;
}
.product-info {
  padding: 10px;
  display: flex;
  flex: 1;
}
.product-img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  & > img {
    width: 80px;
    height: 80px;
  }
}
.product-name {
  margin-top: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
.product-desc {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
}
.price,
.count {
  display: flex;
  width: 100px;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e9e9e9;
}
</style>
